import styles from './FriendsHeader.module.css'

const FriendsHeader = () => {
    return (
        <div className={styles.friendsHeader}>
            <div className={styles.friendsHeader__content}>
                <div className={styles.friendsHeader__title}>
                    Доход за инвайты!
                </div>
                <div className={styles.subtitle}>
                    Приглашай друзей и получай <br/> <span>10% от их дохода</span> на свой баланс
                </div>
            </div>
        </div>
    )
}

export default FriendsHeader